/**
 * Platform-free onboarding flow data shared by the mobile app and the web flow
 * host: the authored `en` screens, the shared navigation and progress data, the
 * web composition, the flow identity, and the pure helpers that travel with the
 * flow (answer-key mapping, weekly day dating, week-summary arithmetic, and the
 * step_key → ScreenId analytics table). UI code stays per-platform; this
 * package is what keeps the two flows from drifting.
 */
export * from './en/screens';
export * from './en/web-onboarding-flow';
export * from './flow-id';
export * from './screen-ids';
export * from './answer-keys';
export * from './week-dates';
export * from './calculate-week-summary';
export * from './conversation-mode-surface';
export * from './usage-flow';
